<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-ticket</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.shows') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 15px 0 15px;" />
      <span style="color:rgba(0, 0, 0, 0.54);">{{$t('activity.show')}}</span>
      <v-select
        single-line
        v-if="typesActivity"
        v-model="content.TypeShow"
        :items="typesActivity"
        item-text="Name"
        item-value="ID"
        style="margin: 10px 0 0 15px;"
        @change="handleChangeIsModified"
      />
    </v-toolbar>
    <v-layout wrap>
      <v-flex xs4 text-right style="padding-right: 20px">
        {{ $t('acttiv.primaryColor') }}:
      </v-flex>
      <v-flex xs8>
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.ShowPrimaryColor"
          :onChangeColor="handleChangePrimaryColor"
        />
      </v-flex>
      <v-flex xs4 text-right style="margin-top:20px;padding-right: 20px">
        {{ $t('acttiv.secundaryColor') }}:
      </v-flex>
      <v-flex xs8 style="margin-top:20px;">
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.ShowSecundaryColor"
          :onChangeColor="handleChangeSecundaryColor"
        />
      </v-flex>
      <v-flex xs4 text-right style="margin-top:20px;padding-right: 20px">
        {{ $t('acttiv.titleColor') }}:
      </v-flex>
      <v-flex xs8 style="margin-top:20px;">
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.ShowColor"
          :onChangeColor="handleChangeTitleColor"
        />
      </v-flex>
      <v-flex xs4 text-right style="margin-top:20px;padding-right: 20px">
        {{ $t('acttiv.descriptionColor') }}:
      </v-flex>
      <v-flex xs8 style="margin-top:20px;">
        <custom-color-picker
          :width="'180px'"
          :icon="'mdi-format-color-fill'"
          :color="content.ShowDescriptionColor"
          :onChangeColor="handleChangeDescriptionColor"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import axios from 'axios'
  import api from '@/services/api'
  import CustomColorPicker from '@/components/CustomColorPickerV2'
  export default {
    components: {
      CustomColorPicker
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      DviewLink: null,
      typesActivity: null
    }),
    computed: {
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
    },
    mounted() {
      this.getEnterprise()
    },
    methods: {
      getEnterprise () {
        api.getItem('enterprises', false, this.$store.state.app.enterpriseID).then(response => {
          this.DviewLink = response.DviewLinkShows
          this.handleGetTypeShows()
        })
      },
      handleGetTypeShows () {
        this.data = axios.get(`https://www.dviewcontent.com/api/p_show/${this.DviewLink}/dtouch-type-show`)
          .then(response => {
            const aux = response.data[0]
            this.typesActivity = [
              {
                ID: 0,
                Name: 'TODOS'
              },
              {
                ID: 1,
                Name: aux.TypeShow01 && aux.TypeShow01.length > 0 ? aux.TypeShow01 : 'Type 01'
              },
              {
                ID: 2,
                Name: aux.TypeShow02 && aux.TypeShow02.length > 0 ? aux.TypeShow02 : 'Type 02'
              },
              {
                ID: 3,
                Name: aux.TypeShow03 && aux.TypeShow03.length > 0 ? aux.TypeShow03 : 'Type 03'
              },
              {
                ID: 4,
                Name: aux.TypeShow04 && aux.TypeShow04.length > 0 ? aux.TypeShow04 : 'Type 04'
              },
              {
                ID: 5,
                Name: aux.TypeShow05 && aux.TypeShow05.length > 0 ? aux.TypeShow05 : 'Type 05'
              }
            ]
          })
      },
      handleChangePrimaryColor (color) {
        this.content.ShowPrimaryColor = color
        this.handleChangeIsModified()
      },
      handleChangeSecundaryColor (color) {
        this.content.ShowSecundaryColor = color
        this.handleChangeIsModified()
      },
      handleChangeTitleColor (color) {
        this.content.ShowColor = color
        this.handleChangeIsModified()
      },
      handleChangeDescriptionColor (color) {
        this.content.ShowDescriptionColor = color
        this.handleChangeIsModified()
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = false
      }
    }
  }
</script>

<style scoped>
</style>

